import { Check } from 'lucide-react'

import { cn } from '@/utils/cn'

interface WizardStepsProps {
  steps: readonly string[]
  current: number
}

/** Indicador de passos numerados com check nos concluídos (formulários em várias etapas). */
export function WizardSteps({ steps, current }: WizardStepsProps) {
  return (
    <ol className="flex flex-wrap gap-2">
      {steps.map((label, index) => (
        <li key={label} className="flex items-center gap-2">
          <span
            className={cn(
              'grid size-6 place-items-center rounded-full text-xs font-semibold',
              index < current && 'bg-brand text-white',
              index === current && 'bg-brand/15 text-brand ring-1 ring-brand',
              index > current && 'bg-surface-2 text-fg-subtle',
            )}
          >
            {index < current ? <Check className="size-3.5" /> : index + 1}
          </span>
          <span
            className={cn('text-sm', index === current ? 'font-medium text-fg' : 'text-fg-muted')}
          >
            {label}
          </span>
        </li>
      ))}
    </ol>
  )
}
